import { can } from "./index.js"

/**
 * @name v-can
 * @description Custom directive for vue to hide stuff based on permissions
 * @param el - DOM el = component v-can was applied on
 * @param binding.value = what was passed in v-can, e.g. v-can="writeIndividuals"
 * can be string or array
 */

// Will be triggered on bind and update
export default (el, binding) => {
	const permission = binding.value
	const operator = binding.arg

	// if (typeof permission === "function") {
	// 	let perm = binding.value()
	// 	console.log(can(perm))
	// 	// If permission is string
	// 	if (can(perm)) return
	// 	else el.style.display = "none"
	// }

	if (typeof permission === "object") {
		// If permission is array
		if (operator === "or") {
			// At least one can(permission) has to be === true
			if (permission.map(item => can(item)).find(item => item === true)) return
			else el.style.display = "none"
		} else {
			// Every can(permission) has to be === true
			if (permission.map(item => can(item)).every(item => item === true)) return
			else el.style.display = "none"
		}

		return
	}

	// If permission is string
	if (can(permission) === false) el.style.display = "none"
}
